import "./SideMenu.scss";

import Sidebar from "react-sidebar";
import { useEffect, useState } from "react";
import { IoArrowBack } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import logo from "../../assets/images/logo_lingo.svg";
import MenuImg from "../../assets/images/menu/icon_mobile_menu.png";
// import Menuback from "../../assets/images/menu/icon_mobile_menu_back.png";

import {
  logout,
  loadUserStorage,
  validateVersion,
  refreshCacheTeacher,
  handleCalendarInitialParams,
} from "../../store/middleware";
import ShareButton from "./ShareButton";
import MenuItemLingo from "./MenuItemLingo";
import { appVersion } from "../../utils/utils";
import DialogModal from "../../components/DialogModal";
import { setLanguage } from "../../store/slices/user.slice";
import ChangeLanguageSelect from "../ChangeLanguage/ChangeLanguage";
import { setButtonBeAffiliatedMenu } from "../../store/slices/affiliate.slice";
import { setActiveTabStudent, setDropDownMenu } from "../../store/slices/generics.slice";

const mql = window.matchMedia("(min-width: 1024px)");

function SideMenu() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { user, checkout } = useSelector((state) => state.userReducer);
  const { selectedStart } = useSelector((state) => state.calendarReducer);
  const { lengthNotif, dropDownMenu } = useSelector((state) => state.genericReducer);
  const { isAffiliate, affiliateInfo } = useSelector((state) => state.affiliateReducer);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarDocked, setSidebarDocked] = useState(true);
  const [showModalVersion, setShowModalVersion] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [selected] = useState(window.location.pathname.split("/")[1]);
  const [sidebarWidth, setSidebarWidth] = useState(mql.matches ? 220 : "100vw");
  const [dialog, setDialog] = useState({ title: "", message: "", opened: false, onClose: () => {} });

  const viewHeight = window.innerHeight;
  const linkWhatsapp = "https://api.whatsapp.com/send?phone=17866129231";

  const handleResize = () => setWindowWidth(window.innerWidth);

  const changeLanguage = async (e) => {
    i18n.changeLanguage(e);
    dispatch(setLanguage(e));
    await dispatch(refreshCacheTeacher(user.teacherId)).then(() => {
      if (window.location.pathname !== "/calendar") {
        !checkout && dispatch(loadUserStorage(true, false, "menu"));
      } else {
        dispatch(handleCalendarInitialParams("list", selectedStart));
      }
    });
  };

  const handleSelected = () => {
    return selected === "users"
      ? true
      : selected === "languages"
      ? true
      : selected === "countries"
      ? true
      : selected === "parameterization"
      ? true
      : selected === "tickets"
      ? true
      : selected === "rating"
      ? true
      : selected === "economic-group"
      ? true
      : selected === "notifications-settings"
      ? true
      : false;
  };

  const handleValidateVersion = async () => {
    await dispatch(validateVersion(user?.id, appVersion)).then((res) => {
      if (res && res.erro === 1) {
        setDialog({
          opened: true,
          title: t("TITLE_MODAL_VERSION"),
          onClose: () => dispatch(logout()),
          message: t("MESSAGE_MODAL_VERSION"),
        });
      }
    });
  };

  const calculateAffiliatePending = () => {
    const conditions = [
      user?.picture === null,
      affiliateInfo?.affiliateTaxInformations?.length === 0,
      user?.role === "student" && affiliateInfo?.affiliatePaymentMethods?.length === 0,
    ];
    return conditions.reduce((count, condition) => (condition ? count + 1 : count), 0);
  };

  const roleMenu = () => {
    switch (user?.role) {
      case "affiliate":
        return (
          <div>
            <li className="myAccount">
              <Link to="/manage-account">
                <MenuItemLingo
                  name={t("ITEM_ACCOUNT")}
                  icon={"account"}
                  isSelected={selected === "manage-account" || selected === "first-access" ? true : false}
                />
              </Link>
            </li>
            <li>
              <Link to="/home">
                <MenuItemLingo name={t("HOME")} icon={"home"} isSelected={selected === "home" ? true : false} />
              </Link>
            </li>
            <li>
              <Link to="/customer-service">
                <MenuItemLingo
                  icon={"customer_service"}
                  name={t("CUSTOMER_SERVICE")}
                  isSelected={selected === "customer-service" ? true : false}
                />
              </Link>
            </li>
            <li>
              <a rel="noreferrer" href={linkWhatsapp} target="_blank">
                <MenuItemLingo
                  icon={"whatsapp"}
                  name={t("WHATSAPP_SUPPORT")}
                  isSelected={selected === "whatsapp" ? true : false}
                />
              </a>
            </li>
            <li>
              <Link to="/notifications">
                <MenuItemLingo
                  icon={"notifications"}
                  name={t("NOTIFICATIONS")}
                  isSelected={selected === "notifications" ? true : false}
                  hasNotification={lengthNotif}
                />
              </Link>
            </li>
            <li></li>
          </div>
        );

      case "student":
        return (
          <div>
            {user?.firstAccess ? (
              <li className="myAccount">
                <Link to="/manage-account">
                  <MenuItemLingo
                    icon={"account"}
                    name={t("ITEM_ACCOUNT")}
                    isSelected={selected === "manage-account" || selected === "first-access" ? true : false}
                  />
                </Link>
              </li>
            ) : (
              <>
                <li className="myAccount">
                  <Link to="/manage-account">
                    <MenuItemLingo
                      icon={"account"}
                      name={t("ITEM_ACCOUNT")}
                      isSelected={selected === "manage-account" || selected === "first-access" ? true : false}
                    />
                  </Link>
                </li>
                <li>
                  <Link to="/home">
                    <MenuItemLingo name={t("HOME")} icon={"home"} isSelected={selected === "home" ? true : false} />
                  </Link>
                </li>
                <li>
                  <Link to="/content">
                    <MenuItemLingo
                      icon={"content"}
                      name={t("CONTENT")}
                      isSelected={selected === "content" ? true : false}
                    />
                  </Link>
                </li>
                <li>
                  <Link to="/calendar">
                    <MenuItemLingo
                      icon={"schedule"}
                      name={t("SCHEDULE")}
                      isSelected={selected === "calendar" ? true : false}
                    />
                  </Link>
                </li>
                <li>
                  <Link to="/class-rating">
                    <MenuItemLingo
                      icon={"rating"}
                      name={t("CLASS_RATING")}
                      isSelected={selected === "class-rating" ? true : false}
                    />
                  </Link>
                </li>
                <li>
                  <Link to="/customer-service">
                    <MenuItemLingo
                      icon={"customer_service"}
                      name={t("CUSTOMER_SERVICE")}
                      isSelected={selected === "customer-service" ? true : false}
                    />
                  </Link>
                </li>
                <li>
                  <a rel="noreferrer" href={linkWhatsapp} target="_blank">
                    <MenuItemLingo
                      icon={"whatsapp"}
                      name={t("WHATSAPP_SUPPORT")}
                      isSelected={selected === "whatsapp" ? true : false}
                    />
                  </a>
                </li>
                <li>
                  <Link to="/notifications">
                    <MenuItemLingo
                      icon={"notifications"}
                      name={t("NOTIFICATIONS")}
                      hasNotification={lengthNotif}
                      isSelected={selected === "notifications" ? true : false}
                    />
                  </Link>
                </li>

                {isAffiliate?.length !== 0 && isAffiliate[0] && (
                  <li>
                    <Link to="/home">
                      <button onClick={() => dispatch(setButtonBeAffiliatedMenu(true))}>
                        <div className="buttonAffiliate">{t("BE_AFFILIATED")}</div>
                      </button>
                    </Link>
                  </li>
                )}
                {affiliateInfo?.length !== 0 && (
                  <li>
                    <Link to="/affiliate">
                      <MenuItemLingo
                        icon={"affiliate"}
                        name={t("BE_AFFILIATED")}
                        hasNotification={calculateAffiliatePending()}
                        isSelected={selected === "affiliate" ? true : false}
                      />
                    </Link>
                  </li>
                )}
              </>
            )}
          </div>
        );

      case "teacher":
        return (
          <div>
            <li className="myAccount">
              <Link to="/manage-account">
                <MenuItemLingo
                  icon={"account"}
                  name={t("ITEM_ACCOUNT")}
                  isSelected={selected === "manage-account" || selected === "first-access" ? true : false}
                />
              </Link>
            </li>
            <li>
              <Link to="/home">
                <MenuItemLingo name={t("HOME")} icon={"home"} isSelected={selected === "home" ? true : false} />
              </Link>
            </li>
            <li>
              <Link to="/content">
                <MenuItemLingo
                  icon={"content"}
                  name={t("CONTENT")}
                  isSelected={selected === "content" ? true : false}
                />
              </Link>
            </li>
            <li>
              <Link to="/report">
                <MenuItemLingo
                  icon={"report"}
                  name={t("REPORT_FORM")}
                  isSelected={selected === "report" || selected === "report-details" ? true : false}
                />
              </Link>
            </li>
            <li>
              <Link to="/calendar">
                <MenuItemLingo
                  icon={"schedule"}
                  name={t("SCHEDULE")}
                  isSelected={selected === "calendar" ? true : false}
                />
              </Link>
            </li>
            <li>
              <Link to="/customer-service">
                <MenuItemLingo
                  icon={"customer_service"}
                  name={t("CUSTOMER_SERVICE")}
                  isSelected={selected === "customer-service" ? true : false}
                />
              </Link>
            </li>
            <li>
              <a rel="noreferrer" href={linkWhatsapp} target="_blank">
                <MenuItemLingo
                  icon={"whatsapp"}
                  name={t("WHATSAPP_SUPPORT")}
                  isSelected={selected === "whatsapp" ? true : false}
                />
              </a>
            </li>
            <li>
              <Link to="/notifications">
                <MenuItemLingo
                  icon={"notifications"}
                  name={t("NOTIFICATIONS")}
                  isSelected={selected === "notifications" ? true : false}
                  hasNotification={lengthNotif}
                />
              </Link>
            </li>
            {isAffiliate?.length !== 0 && isAffiliate[0] && (
              <li>
                <Link to="/home">
                  <button onClick={() => dispatch(setButtonBeAffiliatedMenu(true))}>
                    <div className="buttonAffiliate">{t("BE_AFFILIATED")}</div>
                  </button>
                </Link>
              </li>
            )}
            {affiliateInfo?.length !== 0 && (
              <li>
                <Link to="/affiliate">
                  <MenuItemLingo
                    icon={"affiliate"}
                    name={t("BE_AFFILIATED")}
                    hasNotification={calculateAffiliatePending()}
                    isSelected={selected === "affiliate" ? true : false}
                  />
                </Link>
              </li>
            )}
          </div>
        );

      case "customerService":
        return (
          <div>
            <li className="myAccount">
              <Link to="/manage-account">
                <MenuItemLingo
                  name={t("ITEM_ACCOUNT")}
                  icon={"account"}
                  isSelected={selected === "manage-account" || selected === "first-access" ? true : false}
                />
              </Link>
            </li>
            <li>
              <Link to="/home">
                <MenuItemLingo name={t("HOME")} icon={"home"} isSelected={selected === "home" ? true : false} />
              </Link>
            </li>
            <li>
              <Link to="/content">
                <MenuItemLingo
                  name={t("CONTENT")}
                  icon={"content"}
                  isSelected={selected === "content" ? true : false}
                />
              </Link>
            </li>
            <li>
              <Link to="/calendar">
                <MenuItemLingo
                  name={t("SCHEDULE")}
                  icon={"schedule"}
                  isSelected={selected === "Calendar" ? true : false}
                />
              </Link>
            </li>

            <li>
              <Link to="/demo-class">
                <MenuItemLingo
                  name={t("DEMO_CLASS")}
                  icon={"demo_classes"}
                  isSelected={selected === "demo-class" ? true : false}
                />
              </Link>
            </li>

            <li>
              <Link to="/teachers">
                <MenuItemLingo
                  name={t("TEACHERS")}
                  icon={"teachers"}
                  isSelected={selected === "teachers" ? true : false}
                />
              </Link>
            </li>

            <li onClick={() => dispatch(setActiveTabStudent("PERSONAL_INFO"))}>
              <Link to="/manage-student">
                <MenuItemLingo
                  name={t("STUDENTS")}
                  icon={"students"}
                  isSelected={selected === "manage-student" ? true : false}
                />
              </Link>
            </li>
            <li>
              <Link to="/class-rating">
                <MenuItemLingo
                  name={t("CLASS_RATING")}
                  icon={"rating"}
                  isSelected={selected === "class-rating" ? true : false}
                />
              </Link>
            </li>
            <li>
              <Link to="/manage-affiliate">
                <MenuItemLingo
                  icon={"affiliate"}
                  name={t("AFFILIATES")}
                  isSelected={selected === "manage-affiliate" ? true : false}
                />
              </Link>
            </li>
            <li>
              <Link to="/customer-service">
                <MenuItemLingo
                  name={t("Customer Service")}
                  icon={"customer_service"}
                  isSelected={selected === "customer-service" ? true : false}
                />
              </Link>
            </li>

            <li>
              <Link to="/notifications">
                <MenuItemLingo
                  name={t("NOTIFICATIONS")}
                  icon={"notifications"}
                  isSelected={selected === "notifications" ? true : false}
                  hasNotification={lengthNotif}
                />
              </Link>
            </li>
          </div>
        );

      case "companyManager":
        return (
          <div>
            <li className="myAccount">
              <Link to="/manage-account">
                <MenuItemLingo
                  name={t("ITEM_ACCOUNT")}
                  icon={"account"}
                  isSelected={selected === "manage-account" || selected === "first-access" ? true : false}
                />
              </Link>
            </li>
            <li>
              <Link to="/home">
                <MenuItemLingo name={t("HOME")} icon={"home"} isSelected={selected === "home" ? true : false} />
              </Link>
            </li>
            <li>
              <Link to="/content">
                <MenuItemLingo
                  name={t("CONTENT")}
                  icon={"content"}
                  isSelected={selected === "content" ? true : false}
                />
              </Link>
            </li>
            <li>
              <Link to="/calendar">
                <MenuItemLingo
                  name={t("SCHEDULE")}
                  icon={"schedule"}
                  isSelected={selected === "calendar" ? true : false}
                />
              </Link>
            </li>

            <li>
              <Link to="/demo-class">
                <MenuItemLingo
                  name={t("DEMO_CLASS")}
                  icon={"demo_classes"}
                  isSelected={selected === "demo-class" ? true : false}
                />
              </Link>
            </li>

            <li>
              <Link to="/teachers">
                <MenuItemLingo
                  name={t("TEACHERS")}
                  icon={"teachers"}
                  isSelected={selected === "teachers" ? true : false}
                />
              </Link>
            </li>

            <li onClick={() => dispatch(setActiveTabStudent("PERSONAL_INFO"))}>
              <Link to="/manage-student">
                <MenuItemLingo
                  icon={"students"}
                  name={t("STUDENTS")}
                  isSelected={selected === "manage-student" ? true : false}
                />
              </Link>
            </li>

            <li>
              <Link to="/customer-service">
                <MenuItemLingo
                  icon={"customer_service"}
                  name={t("CUSTOMER_SERVICE")}
                  isSelected={selected === "customer-service" ? true : false}
                />
              </Link>
            </li>

            <li>
              <Link to="/b2b">
                <MenuItemLingo name={t("B2B")} icon={"b2b"} isSelected={selected === "b2b" ? true : false} />
              </Link>
            </li>

            <li>
              <Link to="/plans-and-prices">
                <MenuItemLingo
                  icon={"plans"}
                  name={t("PLANS_AND_PRICING")}
                  isSelected={selected === "plans-and-prices" ? true : false}
                />
              </Link>
            </li>

            <li>
              <Link to="/notifications">
                <MenuItemLingo
                  icon={"notifications"}
                  name={t("NOTIFICATIONS")}
                  isSelected={selected === "notifications" ? true : false}
                  hasNotification={lengthNotif}
                />
              </Link>
            </li>

            <li>
              <Link to="/class-rating">
                <MenuItemLingo
                  icon={"rating"}
                  name={t("CLASS_RATING")}
                  isSelected={selected === "class-rating" ? true : false}
                />
              </Link>
            </li>

            <li>
              <Link to="/manage-affiliate">
                <MenuItemLingo
                  icon={"affiliate"}
                  name={t("AFFILIATES")}
                  isSelected={selected === "manage-affiliate" ? true : false}
                />
              </Link>
            </li>

            <li className="dropMenu">
              <MenuItemLingo
                icon={"settings"}
                iconSettings={true}
                open={dropDownMenu}
                name={t("SETTINGS")}
                isSelected={dropDownMenu || handleSelected()}
                clickAction={() => dispatch(setDropDownMenu(!dropDownMenu))}
              />
              {dropDownMenu && (
                <ul>
                  <li>
                    <Link to="/push-generator">
                      <MenuItemLingo name="Push Generator" isSelected={selected === "push-generator" ? true : false} />
                    </Link>
                  </li>
                  <li>
                    <Link to="/settings-affiliate">
                      <MenuItemLingo name="Affiliates" isSelected={selected === "settings-affiliate" ? true : false} />
                    </Link>
                  </li>
                  <li>
                    <Link to="/users">
                      <MenuItemLingo name={t("USERS")} isSelected={selected === "users" ? true : false} />
                    </Link>
                  </li>
                  <li>
                    <Link to="/languages">
                      <MenuItemLingo name={t("LANGUAGES")} isSelected={selected === "languages" ? true : false} />
                    </Link>
                  </li>
                  <li>
                    <Link to="/countries">
                      <MenuItemLingo name={t("COUNTRIES")} isSelected={selected === "countries" ? true : false} />
                    </Link>
                  </li>
                  <li>
                    <Link to="/parameterization">
                      <MenuItemLingo
                        name={t("PARAMETERS")}
                        isSelected={selected === "parameterization" ? true : false}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link to="/tickets">
                      <MenuItemLingo name={t("TICKETS")} isSelected={selected === "tickets" ? true : false} />
                    </Link>
                  </li>
                  <li>
                    <Link to="/rating">
                      <MenuItemLingo name={t("RATING")} isSelected={selected === "rating" ? true : false} />
                    </Link>
                  </li>
                  <li>
                    <Link to="/economic-group">
                      <MenuItemLingo
                        name={t("ECONOMIC_GROUP")}
                        isSelected={selected === "economic-group" ? true : false}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link to="/notifications-settings">
                      <MenuItemLingo
                        name={t("NOTIFICATIONS")}
                        isSelected={selected === "notifications-settings" ? true : false}
                      />
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          </div>
        );

      default:
        return <div></div>;
    }
  };

  const handleHamburgerOpen = () => {
    setSidebarOpen(true);
  };
  const handleHamburgerClose = () => {
    setSidebarOpen(false);
  };

  const handleLogout = async () => {
    await dispatch(logout()).then(() => navigate("login"));
  };

  if (showModalVersion === 1) {
    setTimeout(() => {
      handleLogout();
    }, 1000);
  }

  useEffect(() => {
    handleValidateVersion();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setSidebarWidth(windowWidth > 1024 ? 220 : "100vw");
    setSidebarOpen(windowWidth > 1024 ? true : false);
    setSidebarDocked(windowWidth > 1024 ? true : false);
  }, [windowWidth]);

  useEffect(() => {
    calculateAffiliatePending();
    // eslint-disable-next-line
  }, [affiliateInfo]);

  return (
    <>
      <Sidebar
        open={sidebarOpen}
        transitions={false}
        docked={sidebarDocked}
        rootClassName="menuSide"
        styles={{
          overlay: { backgroundColor: "rgba(255,255,255)" },
          sidebar: {
            boxshadow: "rgba(0, 0, 0, 0.15) 0px 0px 0px",
            backgroundColor: "#fff",
            overflow: "hidden",
            width: sidebarWidth,
            position: "fixed",
          },
        }}
        sidebar={
          <div
            className="navContainer"
            style={{
              width: "100%",
              height: viewHeight > 900 ? "85%" : "80%",
              maxHeight: viewHeight > 900 ? "85%" : "80%",
            }}
          >
            <div
              style={{
                width: "100%",
                height: viewHeight > 900 ? "85%" : "80%",
                maxHeight: viewHeight > 900 ? "85%" : "80%",
              }}
            >
              <div className="logo logoMobile">
                <Link to="/home">
                  <img src={logo} alt="Logo Lingo" />
                </Link>

                {!sidebarDocked && <IoArrowBack className="buttonCloseSidebar" onClick={handleHamburgerClose} />}
              </div>
              <hr />
              <ul
                style={{
                  height: viewHeight > 900 ? "80%" : "75%",
                  maxHeight: viewHeight > 900 ? "80%" : "75%",
                  overflowY:
                    user?.role === "student" || user?.role === "teacher"
                      ? "hidden"
                      : dropDownMenu
                      ? "scroll"
                      : viewHeight < 900
                      ? "scroll"
                      : viewHeight > 900
                      ? "hidden"
                      : "hidden",
                }}
              >
                {roleMenu()}
              </ul>
            </div>
            <div className="bottomDiv">
              <span className="logoutButtonNew">
                <MenuItemLingo name={t("LOGOUT")} icon={"logout"} clickAction={handleLogout} />
              </span>
              <div className="language">
                <h2>{t("LANGUAGE")}:</h2>
                <ChangeLanguageSelect onChange={(e) => changeLanguage(e.target.value)} />
              </div>

              <span className="versionPlatform">v{appVersion}</span>

              <hr />

              <ShareButton />
            </div>
          </div>
        }
      />
      {!sidebarDocked && !sidebarOpen && (
        <div className="headerSidebar">
          <button className="buttonOpenSidebar" onClick={handleHamburgerOpen}>
            <img src={MenuImg} />
          </button>
          <Link className="headerLogoSidebar" to="/home">
            <img src={logo} alt="Logo Lingo" />
          </Link>
        </div>
      )}

      <DialogModal opened={dialog.opened} title={dialog.title} onClose={() => setShowModalVersion(1)} buttonLabel="Ok">
        <p className="message">{dialog.message}</p>
      </DialogModal>
    </>
  );
}

export default SideMenu;
